
export function flattenErrors(errors) {
    let ret = [];
    for (const k in errors) {
        ret = [...ret, ...errors[k]];
    }
    return ret;
}